import type { TranslationGetter } from '../../../types';

export class PricingConfiguratorService {
  constructor(private t: TranslationGetter, private isStripe?: boolean) {}

  public api() {
    return {};
  }

  public data() {
    return {
      getLabels: () => {
        const headingKey = this.isStripe
          ? ('application-layer.pricing-configurator.pricing-heading-stripe' as const)
          : ('application-layer.pricing-configurator.pricing-heading' as const);

        const headingPrepayOnlyKey = this.isStripe
          ? ('application-layer.pricing-configurator.pricing-heading-prepay-only-stripe' as const)
          : ('application-layer.pricing-configurator.pricing-heading-prepay-only' as const);

        return {
          heading: this.t(headingKey),
          headingPrepayOnly: this.t(headingPrepayOnlyKey),
          nonprofitTooltip: this.t('application-layer.pricing-configurator.non-profit-tooltip'),
        };
      },
    };
  }

  public handlers() {
    return {};
  }
}
